import { Box, Typography } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import GameCard from '../GameCard/GameCard';

export default function HoleCards() {
    const game = useGame();

    return (
        <Box>
            <Typography align="center" paragraph variant="montserrat514">
                Your Hole Cards
            </Typography>
            <Box display="flex" gap={1}>
                <GameCard index={1} name="hole-1" side={game.holeCardsSide} type={game.holeCards[0]} />
                <GameCard index={2} name="hole-2" side={game.holeCardsSide} type={game.holeCards[1]} />
            </Box>
        </Box>
    );
}
